import React from 'react'
import PropTypes from 'prop-types'

import { Container, Box, Divider } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ErrorBoundary } from '@scoir/error-reporter'
import { PageTitle } from '@scoir/headers'
import Tabs from '@scoir/tabs'
import { Redirect, Route, Switch } from 'react-router-dom'

import EngageSplashPage from 'components/EngageSplashPage'
import { OUTREACH_MESSAGE_TYPES } from './outreach-message-types'
import OutreachMessages from './OutreachMessages'
import { useOutreachTabs } from './OutreachMessages/use-outreach-tabs'

const useStyles = makeStyles({
  root: {
    minHeight: 0,
    backgroundColor: 'white',
    '& a:hover, & a:focus': {
      outline: 'none',
      textDecoration: 'none',
    },
  },
})

export const MESSAGE_ROUTE_ENDPOINTS = Object.keys(OUTREACH_MESSAGE_TYPES)

export const Outreach = ({ match, location, canManageOutreach, supportsStudentOutreach }) => {
  const classes = useStyles()
  const tabs = useOutreachTabs(match.url)
  const currentTab = location.pathname.split('/').pop()

  if (!canManageOutreach) {
    return (
      <EngageSplashPage
        type="messaging"
        featureEnabled={supportsStudentOutreach}
      />
    )
  }

  return (
    <Container
      className="outreach"
      maxWidth="xl"
    >
      <PageTitle title="Outreach Messages" />
      <Box bgcolor="background.paper">
        <Tabs
          scrollButtons="off"
          id="outreach-message-type"
          textColor="inherit"
          items={tabs}
          value={currentTab}
          classes={classes}
        >
          <Divider />
          <ErrorBoundary>
            <Switch>
              <Route
                exact
                path={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[0]}`}
                render={(props) => (
                  <OutreachMessages
                    currentRouteEndpoint={MESSAGE_ROUTE_ENDPOINTS[0]}
                    {...props}
                  />
                )}
              />
              <Route
                exact
                path={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[1]}`}
                render={(props) => (
                  <OutreachMessages
                    currentRouteEndpoint={MESSAGE_ROUTE_ENDPOINTS[1]}
                    {...props}
                  />
                )}
              />
              <Redirect to={`${match.path}/${MESSAGE_ROUTE_ENDPOINTS[0]}`} />
            </Switch>
          </ErrorBoundary>
        </Tabs>
      </Box>
    </Container>
  )
}

Outreach.propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  canManageOutreach: PropTypes.bool,
  supportsStudentOutreach: PropTypes.bool,
}

export default Outreach
